import TableMetricRecords from './table-metric-records';

export default TableMetricRecords;
